import React, { lazy } from 'react';
import { RouteObject } from 'react-router-dom';

const ProducerProfile = lazy(() => import('@pages/producer/ProducerProfile'));

export const ProducerProfileRoutes: RouteObject[] = [
  {
    path: '/producer-profile',
    element: (
      <React.Suspense>
        <ProducerProfile />
      </React.Suspense>
    ),
  },
];